var _path, _rect, _circle, _circle2, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysicalSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83 47C83 66.8823 66.8823 83 47 83C27.1178 83 11 66.8823 11 47C11 27.1178 27.1178 11 47 11C66.8823 11 83 27.1178 83 47Z",
    fill: "#FFD100"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58.7354,
    y: 49.874,
    width: 9.6,
    height: 9.6,
    transform: "rotate(-40.1493 58.7354 49.874)",
    fill: "#FF3333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.1682,
    cy: 47.3528,
    r: 4.8,
    transform: "rotate(-40.1493 69.1682 47.3528)",
    fill: "#FF3333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4045,
    cy: 46.7788,
    r: 4.8,
    transform: "rotate(-40.1493 62.4045 46.7788)",
    fill: "#FF3333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2305 30.5529C49.2305 29.2984 50.2488 28.28 51.5034 28.28C52.7579 28.28 53.7763 29.2984 53.7763 30.5529C53.7763 31.8075 52.7579 32.8258 51.5034 32.8258C50.2488 32.8258 49.2305 31.8075 49.2305 30.5529Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7998 31.2827C39.7998 30.0281 40.8182 29.0098 42.0727 29.0098C43.3273 29.0098 44.3456 30.0281 44.3456 31.2827C44.3456 32.5372 43.3273 33.5556 42.0727 33.5556C40.8182 33.5556 39.7998 32.5372 39.7998 31.2827Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7764 38.0491C45.2252 35.9022 45.7606 33.9127 46.9784 33.5978C48.1962 33.2828 49.6293 34.7683 50.1804 36.9153C50.7316 39.0622 50.1962 41.0516 48.9784 41.3666C47.7606 41.6815 46.3275 40.196 45.7764 38.0491Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1021_20465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 72,
    height: 72
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47C83 66.8823 66.8823 83 47 83C27.1178 83 11 66.8823 11 47C11 27.1178 27.1178 11 47 11C66.8823 11 83 27.1178 83 47Z",
    fill: "#FF7700"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1021_20465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.3203,
    y: 18.2,
    width: 61.92,
    height: 7.2,
    fill: "#33A474"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysicalSkills);
export default __webpack_public_path__ + "static/media/physical_skills.f94704d0f6a00fc5df9e1725f5fd944f.svg";
export { ForwardRef as ReactComponent };